import { render, staticRenderFns } from "./accountsWithdrawal.vue?vue&type=template&id=5b9c7dba&"
import script from "./accountsWithdrawal.vue?vue&type=script&lang=js&"
export * from "./accountsWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports